import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import MainCard from 'components/MainCard';

import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';

const FIELD_CONFIG = [
  ['full_name', 'Full Name'],
  ['phone', 'Phone'],
  ['person_type', 'Person Type'],
  ['role_type', 'Role Type'],
  ['warehouse_name', 'Warehouse Name'],
  ['manage_access', 'Manage Access'],
  ['Status', 'Status'],
  ['father_name', "Father's Name"],
  ['gender', 'Gender'],
  ['state_id', 'State'],
  ['city_id', 'City'],
  ['address', 'Address'],
  ['pincode', 'Pincode'],
  ['document_type', 'ID Type'],
  ['id_number', 'ID Number'],
  ['email_id', 'Email']
];

export default function EmployeeDetails() {
  const navigate = useNavigate();
  const { id: warehouseId, employeeId } = useParams();
  const rows = useSelector((state) => state.employee.rows);
  const selectedEmployee = useSelector((state) => state.employee.selectedEmployee);

  const employee = useMemo(() => {
    if (selectedEmployee && String(selectedEmployee.id) === String(employeeId)) return selectedEmployee;
    return rows.find((item) => String(item.id) === String(employeeId)) || null;
  }, [employeeId, rows, selectedEmployee]);

  return (
    <Grid container rowSpacing={2}>
      <Grid size={12}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Button startIcon={<ArrowLeftOutlined />} onClick={() => navigate(`/wareHouse/details/${warehouseId}/employees`)}>
            Back
          </Button>
          <Typography variant="h4">Employee Details</Typography>
        </Stack>
      </Grid>
      <Grid size={12}>
        <MainCard>
          {employee ? (
            <Grid container spacing={2}>
              {FIELD_CONFIG.map(([key, label]) => (
                <Grid key={key} size={{ xs: 12, md: 6 }}>
                  <Typography variant="subtitle2" color="text.secondary">
                    {label}
                  </Typography>
                  <Typography variant="body1">{employee[key] ?? '-'}</Typography>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography variant="body1">Employee data not found in listing state.</Typography>
          )}
        </MainCard>
      </Grid>
    </Grid>
  );
}
